import { useState } from "react";
import { Key, Webhook as WebhookIcon, Router, ScrollText, ShoppingBag, Store, Plug } from "lucide-react";
import { IntegrationsTab } from "./IntegrationsTab";
import { WebhooksTab } from "./WebhooksTab";
import { NetworkDevicesTab } from "./NetworkDevicesTab";
import { ActivityLogTab } from "./ActivityLogTab";
import { ShopifyTab } from "./ShopifyTab";
import { MerchantProTab } from "./MerchantProTab";
import { WooConnectorTab } from "./WooConnectorTab";

type TabKey = "integrations" | "webhooks" | "network" | "log" | "shopify" | "merchantpro" | "wooconnector";

const TABS: { key: TabKey; label: string; icon: typeof Key }[] = [
  { key: "integrations", label: "Integracije i API ključevi", icon: Key },
  { key: "webhooks", label: "Webhookovi", icon: WebhookIcon },
  { key: "network", label: "Mrežni uređaji", icon: Router },
  { key: "log", label: "Log fiskalizacije", icon: ScrollText },
  { key: "shopify", label: "Shopify", icon: ShoppingBag },
  { key: "merchantpro", label: "MerchantPro", icon: Store },
  { key: "wooconnector", label: "WooCommerce konektor", icon: Plug },
];

export function IntegrationsPage() {
  // ?tab=shopify - povratak iz Shopify OAuth-a (callback preusmerava ovde).
  const initialTab = new URLSearchParams(window.location.search).get("tab") === "shopify" ? "shopify" : "integrations";
  const [tab, setTab] = useState<TabKey>(initialTab);

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-semibold text-slate-900">HAFiskal Cloud API</h1>
        <p className="text-sm text-slate-500">
          Poveži WooCommerce, WHMCS, Shopify, MerchantPro, POS ili sopstveni sistem sa HAFiskal-om preko API-ja
        </p>
      </div>

      <div className="flex gap-1 border-b border-border">
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            className={`flex items-center gap-1.5 border-b-2 px-4 py-2 text-sm font-medium ${
              tab === t.key
                ? "border-brand text-brand"
                : "border-transparent text-slate-500 hover:text-slate-700"
            }`}
          >
            <t.icon className="h-4 w-4" aria-hidden />
            {t.label}
          </button>
        ))}
      </div>

      {tab === "integrations" && <IntegrationsTab />}
      {tab === "webhooks" && <WebhooksTab />}
      {tab === "network" && <NetworkDevicesTab />}
      {tab === "log" && <ActivityLogTab />}
      {tab === "shopify" && <ShopifyTab />}
      {tab === "merchantpro" && <MerchantProTab />}
      {tab === "wooconnector" && <WooConnectorTab />}
    </div>
  );
}
